import { LabelToggleButton } from "../../../ui/LabelToggleButton";
import { ToggleButton } from "../../../ui/ToggleButton";
import { GetBounds } from "../../../utils/GetBounds";
import { RectSize } from "../../../utils/RectSize";


export class OptionsLeafPopupImageItem
    // extends LabelToggleButton
    extends ToggleButton {
    /**
     * Parent sets view origin to 0,0, which pushes hitArea..
     * fix hitArea here.
     * 
     * TODO: best case scenario, setOrigin will be included in hitArea calc.
     */
    protected override UpdateHitArea(): void {
        // console.log(this.hitAreaExtrusion);

        this.cachedHitArea = GetBounds(this.view, this.hitAreaExtrusion);
        // hack back proper hitArea
        this.cachedHitArea.x += this.view.displayWidth / 2;
        this.cachedHitArea.y += this.view.displayHeight / 2;
        this.cachedHitAreaCallback = Phaser.Geom.Rectangle.Contains;

        if (this.input != null) {
            this.input.hitArea = this.cachedHitArea;
            this.input.hitAreaCallback = this.cachedHitAreaCallback;
        }
    }
}